// ==============================|| OVERRIDES - TABLE PAGINATION ||============================== //

export default function TablePagination(theme) {
  return {
    MuiTablePagination: {
      styleOverrides: {
        root: {
          borderTop: `1px solid ${theme.palette.divider}`,
          width: '100%',
          padding: '0px 20px'
          //   maxHeight: '36px',
          //   height: '36px'
        },
        toolbar: {
          height: '36px',
          padding: '0px 20px',
          minHeight: '36px'
        },
        select: {
          fontSize: 'inherit'
        },
        displayedRows: {
          fontSize: 'inherit'
        },
        selectLabel: {
          fontSize: 'inherit'
        }
      }
    }
  };
}
